import { gql } from '@apollo/client';
import { UserPermissionFragment } from '../../../utils/apollo/permission/fragments';

export default gql`
  mutation Login {
    userLogin {
      entity {
        ...UserPermissionFields
      }
      userIdHashed
    }
  }
  ${UserPermissionFragment}
`;
